import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SIGN_FORM_ADDRESS_REMOVAL_EXPERIMENT = defineFcm('sign_form_address_removal_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Sign Form',
		description:
			'Runtime kill switch for the sign_form_address_removal_experiment. When disabled the experiment ' +
			'resolves to control with fallbackReason "disabled" and the sign form keeps showing the ' +
			'IP-derived address ask to US guest signers on national/global petitions.',
		import: false,
		template: { enabled: true },
	});
